import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CustomerService } from '../../core/services/customer.service';

@Directive({
    selector: '[appAgentWritable]',
    standalone: true
})
export class AgentWritableDirective implements OnInit {

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private customerService: CustomerService
    ) { }

    ngOnInit() {
        const isJubooAgent = this.customerService.getIsJubooAgent();

        if (!isJubooAgent) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
